import React from "react";
import { labels } from "../../../../../../localization/labels";
import InvolvementRoleService from "../../../../../../services/InvolvementRoleService";
import InvolvementRoleTypeService from "../../../../../../services/InvolvementRoleTypeService";
import CommonUtil from "../../../../../../utils/CommonUtil";
import {
  individualValidationRules as validationRules,
  validateEntity
} from "../../../../../../validators/validationRules";
import TableUtils from "../../../../../core/Table/TableUtils";
import TableComponentWithDialog from "../../../../page/TableComponentWithDialog";
import InvolvementRoles from "./InvolvementRoles";
import PathUtil from "../../../../../../utils/PathUtil";
import { paths } from "../../../../../paths";
import { withRouter } from "react-router-dom";
import { withKeycloak } from "@react-keycloak/web";

class InvolvementRolesContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);

    this.involvementRoleService = new InvolvementRoleService(this.keycloak);
    this.involvementRoleTypeService = new InvolvementRoleTypeService(
      this.keycloak
    );
    this.allInheritedDataShouldBeDefined = true;

    this.state = {
      ...this.state,
      involvementRoleTypes: [],
      id: this.resolveItemId(),
      partyId: PathUtil.pathParameter(this.props, "partyId"),
      organisationId: PathUtil.pathParameter(this.props, "organisationId")
    };
  }

  loadData = pageInfo => {
    if (this.props.involvementRolesUrl) {
      this.prepareCall(
        this.involvementRoleService.getEntitiesWithParams(
          this.props.involvementRolesUrl,
          pageInfo,
          this.sortInfo,
          this.onDataLoad,
          this.messageHandler.handleError
        )
      );

      this.performCalls();
    }
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "involvementRoleTypeName",
      text: labels.name,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  possibleSizesPerPage() {
    return [5, 10, 15];
  }

  onDeleteData = entity => {
    this.prepareCall(
      this.involvementRoleService.deleteEntity(
        entity,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  handleDialogChange = event => {
    let { newEntity } = this.state;
    const path = event.target.id;
    CommonUtil.setDeepOnStringPath(newEntity, path, event.target.value);
    const disabled = !this.validator(newEntity);
    this.setState({ newEntity, disabled });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.involvementRoles);
  };

  selectRow = {
    mode: "checkbox",
    selectColumnStyle: {
      textAlign: "center"
    },
    headerColumnStyle: {
      textAlign: "center"
    }
  };

  updateData = entity => {
    this.prepareCall(
      this.involvementRoleService.patchEntity(
        entity,
        this.state.oldEntity,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onCreateData = entity => {
    this.prepareCall(
      this.involvementRoleService.postEntity(
        entity,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRowClick = (_, row) => {
    let path;
    let partyId;

    if (this.state.organisationId !== undefined) {
      path = paths.ORGANISATIONS;
      partyId = this.state.organisationId;
    } else {
      path = paths.INDIVIDUALS;
      partyId = this.state.partyId;
    }

    const itemPath = PathUtil.adminItemsPath(
        {
          path: path,
          partyId: partyId
        },
        {
          path: paths.PARTYROLES,
          partyRoleId: this.state.id
        },
        {path: paths.INVOLVEMENTROLES, id: row.id}
    );

    this.changePath(itemPath, row.id, {
      partyRoleType: this.props.partyRoleType
    });
  };

  handleCreate = () => {
    let path;
    let partyId;

    if (this.state.organisationId !== undefined) {
      path = paths.ORGANISATIONS;
      partyId = this.state.organisationId;
    } else {
      path = paths.INDIVIDUALS;
      partyId = this.state.partyId;
    }

    const itemPath = PathUtil.adminItemsPath(
        {
          path: path,
          partyId: partyId
        },
        {
          path: paths.PARTYROLES,
          partyRoleId: this.state.id
        },
        {path: paths.INVOLVEMENTROLES}
    );

    this.changePath(itemPath, labels.involvementRole, {
      partyRoleType: this.props.partyRoleType
    });
  };

  render() {
    return (
      <>
        <InvolvementRoles
          {...this.renderProps()}
          disabled={this.state.disabled}
          validationRule={validationRules.involvementRoles}
          involvementRoleTypes={this.state.involvementRoleTypes}
          handleCreate={this.handleCreate}
        />
      </>
    );
  }
}

export default withKeycloak(withRouter(InvolvementRolesContainer));
